import React, { useEffect, useState, useRef } from 'react';
import './style.scss';
import query from 'query-string';
import ReactPlayer from 'react-player';
import back from '../../assets/images/Back.png';
import cancel from '../../assets/images/Cancel.png';
import deleteIcon from '../../assets/images/Delete.png';
import camera from '../../assets/images/camera.png';
import 'firebase/storage';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';

const CreateSnag = ({
}) => {
    const bodyRef = useRef(null);
    const submitRef = useRef(null);
    let navigate = useNavigate();
    let location = useLocation();
    const [issueType, setIssueType] = useState('SNAG');
    const [stageRef, setStageRef] = useState(null);
    const [missingField, setMissingField] = useState([]);
    const [updated, updateList] = useState(false);
    const [imageProcessing, setImageProcessing] = useState(false);
    const [ongoingStages, setOngoingStage] = useState([]);
    const [viewDetails, setViewDetails] = useState(false);
    const [errorToast, setErrorToast] = useState(false);
    const [limitToast, setLimitToast] = useState(false);
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [imageList, setImageList] = useState([]);
    const [videoIdx, setVideoIdx] = useState(new Set());
    const [overlayVisible, setOverlayVisible] = useState(false);
    const [baseData, setBaseData] = useState({});
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    useEffect(() => {
        updateList(!updated);
    }, [issueType, viewDetails]);

    const createNewIssue = () => {
        let errorFields = missingField;
        if (!stageRef) {
            errorFields.push('Stage');
        }
        if (!(imageList && imageList.length !== 0)) {
            errorFields.push('Media');
        }
        if (!title) {
            errorFields.push('Title');
        }
        if (!description) {
            errorFields.push('Description');
        }
        if (errorFields.length !== 0) {
            submitRef.current.disabled = true;
            return;
        }
        let data = {
            title,
            description,
            refType: 'STAGE',
            refId: stageRef,
            crnId: baseData.crnId,
            siteId: baseData.siteId,
            createdByRole : baseData.role,
            daysToComplete: 3,
            issueType: baseData.issueType,
            createdBy: baseData.userId,
            createdByName: baseData.userName,
            mediaUrls: imageList,
        }
        axios.post(`https://guardian-professional.bricknbolt.com/inspectionService/api/v3/issue/create`, data, {
            headers: {
                'Authorization': `Bearer ${baseData.token}`
            }
        }).then(res => {
            navigate(-1);
            data = res.data;
            submitRef.current.disabled = false;
        }).catch(e => {
            setSubmitDisabled(false);
            setErrorToast(true);
            submitRef.current.disabled = false;
        })
    }
    const getOngoingStages = () => {
        if (baseData && baseData.token && baseData.siteId) {
            axios.get(`https://guardian-professional.bricknbolt.com/inspectionService/api/v3/stage/ongoing/${baseData.siteId}`, {
                headers: {
                    'Authorization': `Bearer ${baseData.token}`
                }
            }).then(res => {
                
                setOngoingStage(res.data.responseData);
            })
        }
    }
    useEffect(() => {
        setBaseData(query.parse(location.search))
    },[]);

    useEffect(() => {
        getOngoingStages();
    },[baseData]);

    useEffect(() => {
        if(limitToast) {
            setTimeout(()=>setLimitToast(false), 1000);
        }
    },[limitToast]);


    const handleFileRemoval = (removedFile) => {
        const data = [];
        imageList.map((file) => {
            if (file === removedFile) {
                return;
            }
            data.push(file);
        });
        const designUrls = data;
        if (designUrls.length === 0 && !missingField.includes('Media')) {
            let errorFields = missingField;
            errorFields.push('Media');
            setMissingField(errorFields);
        }
        setImageList(designUrls);
    };
  
  let list = window.mediaList;
  useEffect(() => {
    if(list && typeof list === 'string'){
        list = list.split(',');
        list[0] = list[0].replace('[', '');
        list[(list.length-1)] = list[(list.length-1)].replace(']', '');
        setImageList([...imageList, ...list]);
        if (!!([...imageList, ...list].length) && missingField.includes('Media')) {
            setMissingField(missingField.filter((i,v) => i !== 'Media'));
        }
        window.mediaList = [];
        setImageProcessing(false);
        let link = document.createElement('input');
        link.setAttribute('value', '');
        document.body.appendChild(link);
        document.body.removeChild(link);
    } else if(imageProcessing) {
        setImageProcessing(false);
    }
  },[updated]);

  useEffect(() => {
    if (imageList.length === 0) {
        window.mediaList = [];
    }
    setOverlayVisible(false);
  },[imageList.length]);

  useEffect(() => {
    const interval = setTimeout(() => {
        if (updated) {
            updateList(false);
        } else {
            updateList(true);
        }
    },2000);

    return () => {
        clearTimeout(interval);
    }
  }, [updated]);


  useEffect(() => {
    if(errorToast) {
        setTimeout(()=>setErrorToast(false), 1500);
    }
},[errorToast]);

useEffect(() => {
    if (missingField.length === 0) {
        submitRef.current.disabled = false;
    }
    if (missingField.length !== 0) {
        submitRef.current.disabled = true;
    }
}, [missingField.length]);

  
  const isVideo = (url) => {
    if (url && typeof url === 'string'){
        let part = url.split('.');
        if(part[(part.length - 1)] === 'mp4'){
            return true;
        }
        else if(part[(part.length - 1)] === 'jpeg' || part[(part.length - 1)] === 'jpg' || part[(part.length - 1)] === 'png') {
            return false;
        }
    }
    else return null;
}

    return (
        <div className='background-div'>
        <div className='app-header'>
            <span onClick={()=>{
                        if (window.history.state.idx === 0) {
                            // eslint-disable-next-line no-undef
                            android.exitWebView();
                        } else {
                            navigate(-1)
                        }
                    }} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: '20px'}}>
                <img src={back} height={25} width={15} />
            </span>
            <label style={{ flex: 2, justifyContent: 'flex-start' }}>Create Snag</label>
        </div>
        <div ref={bodyRef} className='issues-body' style={{ height: (window.innerHeight - 100) }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '90%' }}>
                <label className='field-name'>
                    <span style={{color: 'red'}}>*</span>Stage</label>
                    {missingField.includes('Stage') && (<span style={{ color: 'red', fontSize: '12px', marginTop: '-5px' }}>Required</span>)}
                <select className='stage-select' value={stageRef} onChange={(e)=>{
                    setStageRef(e.target.value);
                    if (!!(e.target.value).trim() && missingField.includes('Stage')) {
                        setMissingField(missingField.filter((i,v) => i !== 'Stage'));
                    } else if (!(e.target.value).trim() && !missingField.includes('Stage')) {
                        let errorFields = missingField;
                        errorFields.push('Stage');
                        setMissingField(errorFields);
                    }
                }}>

                <option disabled selected value>Select Snag Stage</option>
                    {ongoingStages.map((item) => (<option value={item.id}>{item.name}</option>))}
                </select>
                <label className='field-name'><span style={{color: 'red'}}>*</span>Media Uploaded By SE:</label>
                {missingField.includes('Media') && (<span style={{ color: 'red', fontSize: '12px', marginBottom: '10px', marginTop: '-5px' }}>Required</span>)}
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                    <div>
                        <div onClick={() => {
                            if(imageList.length === 10 || imageList.length > 10) {
                                setLimitToast(true);
                                return;
                            }
                            setOverlayVisible(true);
                        }} className="upload-button">
                        <img src={camera} className='upload-img' />
                        </div>
                    </div>
                    {!!(imageList.length) && imageList.map((item, idx) => (<div className='upload-button'>
                        <span className='delete-icon' onClick={()=>{handleFileRemoval(item)
                            }} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <img src={deleteIcon} height={12} width={12} />
                        </span>
                                
                        {isVideo(item) ? 
                        <div className='player-div' style={{ backgroundColor: 'black' }}>
                            {videoIdx.has(idx) && 
                            <div style={{position:'relative', zIndex: 100, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}><div className="overlay-loader"></div></div>}
                            <ReactPlayer 
                                muted
                                loop
                                playing
                                height={'100%'}
                                width={'100%'}
                                stopOnUnmount
                                onBuffer={(data)=>{
                                    let idxs = new Set(videoIdx);
                                    idxs.add(idx);
                                    setVideoIdx(idxs);
                                }}
                                onBufferEnd={(data)=>{
                                    let idxs = new Set(videoIdx);
                                    idxs.delete(idx);
                                    setVideoIdx(idxs);
                                }}
                                style={{ position: 'absolute', top: 0, left:0}}
                                url={item} /></div>
                //         <video width={'70px'} height={'71px'}>
                //     <source src={item} type="video/mp4"/>
                //    </video> 
                   : <img src={item} width={'70px'} height={'71px'} />}
                    </div>))}
                    {imageProcessing && <div><div onClick={() => {
                        setImageProcessing(true);
                    }} className="upload-button">
                            <div className="loader"></div>
                        </div></div>}
                </div>
                <label className='field-name'><span style={{color: 'red'}}>*</span>Snag Title</label>
                {missingField.includes('Title') && (<span style={{ color: 'red', fontSize: '12px', marginTop: '-5px' }}>Required</span>)}
                <textarea className='field-value' maxLength={30} value={title} onChange={(e)=>{
                    if ((e.target.value).length <= 30) {
                        setTitle(e.target.value)
                    }
                    if (!!(e.target.value).trim() && missingField.includes('Title')) {
                        setMissingField(missingField.filter((i,v) => i !== 'Title'));
                    } else if (!(e.target.value).trim() && !missingField.includes('Title')) {
                        let errorFields = missingField;
                        errorFields.push('Title');
                        setMissingField(errorFields);
                    }
                }}/>
                <span className='length-indicator'>{`${title.length}/30`}</span>
                <label className='field-name'><span style={{color: 'red'}}>*</span>Snag Description</label>
                {missingField.includes('Description') && (<span style={{ color: 'red', fontSize: '12px', marginTop: '-5px' }}>Required</span>)}
                <textarea className='field-value' maxLength={250} value={description} onChange={(e)=>{
                    if ((e.target.value).length <= 250) {
                        setDescription(e.target.value)
                    }
                    if (!!(e.target.value).trim() && missingField.includes('Description')) {
                        setMissingField(missingField.filter((i,v) => i !== 'Description'));
                    } else if (!(e.target.value).trim() && !missingField.includes('Description')) {
                        let errorFields = missingField;
                        errorFields.push('Description');
                        setMissingField(errorFields);
                    }
                }}/>
                <span className='length-indicator'>{`${description.length}/250`}</span>
            </div>
            {overlayVisible && <div className='overlay-div'>
                <span className='close-icon' onClick={()=>{
                    setImageProcessing(false);
                    setOverlayVisible(false);
                }} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', top: '42%' }}>
                    <img src={cancel} height={12} width={12} />
                </span>
                <div className='overlay-body' style={{ width: '90%', borderRadius: '12px' }}>
                    <label className='status-txt' style={{ backgroundColor: 'white', textAlign: 'center', marginBottom: '5px', fontWeight: 'bold' }}>Select Action</label>
                    <div style={{display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
                        <div onClick={() => {
                            setImageProcessing(true);
                            // eslint-disable-next-line no-undef
                            android.getVideoUrlFromAndroid();
                            setOverlayVisible(false);
                        }} className='status-button'
                        style={{ border: '1px solid #F15A29', color: '#F15A29', width: '40%', borderRadius: '5px', backgroundColor: 'white' }}>Add Videos</div>
                        <div onClick={() => {
                            setImageProcessing(true);
                            // eslint-disable-next-line no-undef
                            android.getPhotoUrlFromAndroid();
                            setOverlayVisible(false);
                        }} className='status-button'
                        style={{ backgroundColor: '#F15A29', width: '40%', borderRadius: '5px' }}>Add Photos</div>
                    </div>
                </div>
            </div>}

            {limitToast && <div className='overlay-div' style={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: 'transparent'}}>
                <label className='toast'>{'Max limit reached.'}</label>
            </div>}

            {errorToast && <div className='overlay-div' style={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: 'transparent'}}>
                <label className='toast'>{`Something went wrong! Try Again.`}</label>
            </div>}

            <div className='overlay-btn-grp'>
            <button ref={submitRef} onClick={() => {
                    createNewIssue();
                }} className='status-button' style={{ backgroundColor: (submitRef && submitRef.current && submitRef.current.disabled === true) ? '#ddd' : '#F15A29', borderColor: 'transparent', padding: '10px', minHeight: '35px', minWidth: '100px', fontSize: '15px' }}>Submit</button>
            </div>
        </div>
        </div>
    )
};

export default CreateSnag;